import { template as template_8ed3c320e34b4ec09f9573d9c6ec0305 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import styles from './panel-loading-state.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
export default class RequestClinicianSearchFiltersPanelLoadingState extends Component {
    styles = styles;
    static{
        template_8ed3c320e34b4ec09f9573d9c6ec0305(`
    <div class={{this.styles.loadingState}} role="status" aria-live="polite" ...attributes>
      {{svgJar "circle-notch" class="icon-spinner" aria-label=@ariaLabel}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
